<template>
	<div class="flow-form-wrapper">
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "FormWrapper"
});
</script>
<style lang="scss">
div.flow-form-wrapper {
	display: flex;
	flex-direction: column;

	// > div.flow-form-field-wrapper + div.flow-form-field-wrapper {
	// 	// margin-top: 24px;
	// 	margin-top: 16px;
	// }

	// > * + * {
	// 	margin-top: 16px;
	// }
}
</style>
